"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This class adds the functionality to allow for a set of unique observers to be added to the
 * video frame processor.
 */

/** @internal */

var BackgroundFilterVideoFrameProcessorDelegate = /*#__PURE__*/function () {
  function BackgroundFilterVideoFrameProcessorDelegate() {
    _classCallCheck(this, BackgroundFilterVideoFrameProcessorDelegate);

    this.observers = new Set();
  }
  /**
   * Add an observer to the unique set. If a duplicate observer cannot be added.
   * @param observer An implementation of the observer interface.
   */


  _createClass(BackgroundFilterVideoFrameProcessorDelegate, [{
    key: "addObserver",
    value: function addObserver(observer) {
      this.observers.add(observer);
    }
    /**
     * Remove the observer from the set of observers.
     * @param observer An implementation of the observer interface.
     */

  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observers.delete(observer);
    }
    /**
     * Call the observer method with the event information. See [[BackgroundFilterVideoFrameProcessorObserver]]
     * for detailed info on this event.
     * @param event
     */

  }, {
    key: "filterFrameDurationHigh",
    value: function filterFrameDurationHigh(event) {
      var _a;

      var _iterator = _createForOfIteratorHelper(this.observers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          (_a = observer.filterFrameDurationHigh) === null || _a === void 0 ? void 0 : _a.call(observer, event);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "filterCPUUtilizationHigh",
    value: function filterCPUUtilizationHigh(event) {
      var _a;

      var _iterator2 = _createForOfIteratorHelper(this.observers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var observer = _step2.value;
          (_a = observer.filterCPUUtilizationHigh) === null || _a === void 0 ? void 0 : _a.call(observer, event);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return BackgroundFilterVideoFrameProcessorDelegate;
}();

exports.default = BackgroundFilterVideoFrameProcessorDelegate;